var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.block},_vm._l((_vm.value),function(item){return _c('CommentItem',{key:item.id,class:_vm._.item,attrs:{"value":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }